import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../../../Components/UiComponents/Table/Table";
import { Editicon, Deleteicon, XCircleblack } from "../../../../Components/IconComponents";
import {
  facilityTableData,
  facilitycolumnsForExport,
} from "../../../../JsonData/CreateFacilityConfig";
import { getData, putDataWithBody } from "../../../../Services/Services";
import {
  getFacilities,
  deleteFacilityURL,
} from "../../../../Services/EndPoints";
import Moment from "react-moment";
import { useDispatch } from "react-redux";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import { toast, ToastContainer } from "react-toastify";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import StatusHandler from "../../Common/StatusHandler/StatusHandler";
import Loader from "react-spinner-loader";
import { useTranslation } from "react-i18next";
import { RoleContext, ThemeContext } from "../../../..";
import TextEllipsis from "../../../../Components/UiComponents/TextEllipsis/TextEllipsis";
import { Button, Modal } from "react-bootstrap";

const FacilityList = () => {
  const { roleName } = useContext(RoleContext);
  const { t } = useTranslation();
  const [data, setData] = useState(facilityTableData);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const navigate = useNavigate();
  const { theme } =useContext(ThemeContext);
  useEffect(() => {
    getFacilityList();
  }, []);

  useEffect(() => {
    sendDataToCentralStore(searchData);
  }, [searchData]);

  const getFacilityList = async () => {
    setLoader(true);
    var facilityList = await getData(getFacilities);
    let sortedList = facilityList.sort((a, b) => {
      return new Date(b.created_on) - new Date(a.created_on);
    });

    setLoader(false);
    setData(sortedList);
    setRowCount(sortedList.length);
    // sendDataToCentralStore(facilityList);
  };
  const addNewHandler = () => {
    navigate("/facility-mgmt/create-facility");
    // localStorage.removeItem("DriverRegForm");
  };

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = facilitycolumnsForExport;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("facilitytableheaders.name"),
        accessor: "name",
        disableSortBy: true,
        Cell: (props) => <TextEllipsis text={props?.value} maxLength={20} />,
      },
      {
        Header: t("facilitytableheaders.address"),
        accessor: "address",
        Cell: (props) => {
          if (props.value) {
            let addressText = props.value;
            if (props.value.length > 15) {
              addressText = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{addressText}</span>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("facilitytableheaders.district"),
        accessor: "dist_name",
        disableSortBy: true,
      },
      {
        Header: t("facilitytableheaders.block"),
        accessor: "block_name",
        disableSortBy: true,
      },
      {
        Header: t("facilitytableheaders.description"),
        accessor: "description",
      
        Cell: (props) => {
          const [showModal, setShowModal] = useState(false);
          const [fullDescription, setFullDescription] = useState("");
          const [highlightedDescription, setHighlightedDescription] = useState(""); // New state for highlighted description
      
          const handleShowModal = (description) => {
            setFullDescription(description);
            setHighlightedDescription(description); // Set the description being viewed to highlight...
            setShowModal(true);
          };
      
          const handleCloseModal = () => {
            setShowModal(false);
            setHighlightedDescription(""); // Reset the highlighted description when the modal is closed
          };
      
          const descriptionText = props.value || "NA";
          const truncatedDescription = descriptionText.length > 15 ? `${descriptionText.substring(0, 15)}...` : descriptionText;
      
          // Apply background color if the description is currently being viewed in the modal
          const isHighlighted = descriptionText === highlightedDescription;
          if (showModal) {
            setTimeout(() => {
              let el = document.querySelector('.modal-content');
              el.style.cssText = 'background-color: #1c2038 !important; border-radius: 20px !important;';
            }, 0);
          }
      
          return (
            <span>
              <span
                title={descriptionText} // Tooltip with full description on hover
                style={{
                  cursor: 'pointer',  // Added pointer cursor to indicate clickability
                  backgroundColor: isHighlighted ? '#18A3A0' : 'transparent', // Highlight background when viewed
                  padding: '2px 5px', // Add padding to give a little space around the text
                  borderRadius: '5px', // Rounded corners for the highlighted background
                }}
                onClick={() => handleShowModal(descriptionText)} // Open the modal with full description
              >
                {truncatedDescription}
              </span>
      
              {/* Modal to display the full description */}
              <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName="custom-modal"
                centered
                style={{
                  borderRadius: '20px',  // Smooth rounded edges
                  border: 'none',        // Remove border to avoid white edges
                  top: '20%',  
                }}
              >
                <Modal.Header
                  style={{
                    backgroundColor: theme === "light" ? "#2b6591" : '#1c2038', // Dark blue background for header
                    color: 'white',              // White text in the header
                    borderBottom: 'none',       // Remove bottom border to prevent white edges
                  }}
                >
                  <Modal.Title style={{ color: 'white' }}>Full Description</Modal.Title>
                  <XCircleblack
                    onClick={handleCloseModal}
                    width="1.5em"
                    height="1.5em"
                    className="cursor-pointer"
                  />
                </Modal.Header>
                <Modal.Body
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : '#252b48', // Blue background for body
                    color: theme === "light" ? "#001b30" : 'white',              // White text in the body
                    border: 'none',              // Remove border to prevent white edges
                    borderRadius: '0px',        // Remove radius to make it seamless
                    padding: '20px',             // Added padding for spacing
                    lineHeight: '1.8', 
                  }}
                >
                  <p>{fullDescription}</p>
                </Modal.Body>
                <Modal.Footer
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : '#252b48', // Darker blue footer
                    color: 'white',              // White text in footer
                    borderTop: 'none',          // Remove top border to prevent white edges
                  }}
                >
                  <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    style={{
                      backgroundColor:theme === "light" ? "#2b6591" :  '#252b48', // Dark blue button
                      borderColor: '#003366',     // Dark border for button
                      borderRadius: '5px',        // Rounded button edges
                    }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </span>
          );
        },
        disableSortBy: true,
      },      
      // {
      //   Header: t("facilitytableheaders.createdon"),
      //   accessor: "created_on",
      //   Cell: (props) => {
      //     if (props.value) {
      //       return <Moment format="DD/MM/YYYY, HH:mm ">{props.value}</Moment>;
      //     } else {
      //       return "NA";
      //     }
      //   },
      //   disableSortBy: true,

      //   // Cell: (props) => <TextEllipsis text={props?.value} maxLength={15} />,
      // },
 
      {
        Header: t("facilitytableheaders.facilitytype"),

        accessor: "facility_type",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return <div>{props.value}</div>;
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("facilitytableheaders.contactlist"),
        accessor: "contact_list",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return <TextEllipsis text={props.value} maxLength={20} />;
          } else {
            return "NA";
          }
        },
      },

      {
        Header: t("facilitytableheaders.action"),
        accessor: "actions",
        disableSortBy: true,
        disableFilters: true,
        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const [isEditMode, setIsEditMode] = useState(true);
          const isFacility = props.row?.original?.facility_type || ""; // Default to empty string if undefined
 
          const disableDeleteValues = [
            "Community Kitchen",
            "Flood Relief Camp",
            "Animal Shelter",
          ];
 
          // Check if isFacility exists and then apply .includes()
          const isDeleteDisabled =
            isFacility &&
            disableDeleteValues.some((value) => isFacility.includes(value));
 
          const deletePopUp = () => {
            setIsdelete(!isdelete);
          };
 
          const deleteTableDataById = async (id) => {
            let data = { id: id };
            var res = await putDataWithBody(deleteFacilityURL, data, {});
            if (res.status === "success") {
              getFacilityList();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000, // Close after 2 seconds
            });
            setIsdelete(false);
          };
 
          const isMultiSelectDisabled = isEditMode;
 
          const handleEditClick = () => {
            setIsEditMode(false); // Enable edit mode (disable MultiSelectWrapper)
          };
 
          return (
            <div className="usertable__actionsicon">
              <span
                className="ms-3"
                onClick={() =>{
                  navigate("/facility-mgmt/create-facility", {
                    state: {
                      data: props.row.original.id,
                      isMultiSelectDisabled: isMultiSelectDisabled,
                      edit: true
                    },
                  });
                  handleEditClick();
                }}>
                <Editicon value={props.value} className="cursor-pointer me-2" />
              </span>
              {roleName === process.env.REACT_APP_SUPER_ADMIN &&
                !isDeleteDisabled && (
                  <span onClick={deletePopUp}>
                    <Deleteicon
                      value={props.value}
                      className="cursor-pointer mr-1"
                    />
                  </span>
                )}
 
              {isdelete && (
                <Confirmpopup
                  className="DeltePopup"
                  show={isdelete}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={props.row.original.name}
                  deleteRow={deleteTableDataById}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )}
            </div>
          );
        },
      },
    ],
    [t, roleName]
  );

  return (
    <div className="create-user">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      <div className="datatable__container">
        {facilityTableData && (
          <Table
            data={data}
            title=""
            showFilter={false}
            columns={columns}
            numberOfRows={10}
            addButtonLabel={t("facilityaddButtonLabel")}
            addNewHandler={addNewHandler}
            setSearchData={setSearchData}
            showExport={false}
            showReset={false}
            onExpand={false}
            showSearch={true}
            isHeaderFixed={true}
            rowCount={rowCount} // Pass rowCount to the Table component
            enableColumnFilters={true}
            headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid #f0f0f0",
              borderRadius: "12px",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default FacilityList;
